import { useState, useEffect } from 'react'
import { ProjectConfig } from '../types/ProjectConfig'
import { getProjectOverviews } from '../helpers/firestore.helpers'

export enum LoadingState {
  loading,
  error,
}

export function useProjectConfig(): ProjectConfig | LoadingState {
  const [projectOverview, setProjectOverview] = useState<
    ProjectConfig | LoadingState
  >(LoadingState.loading)

  useEffect(() => {
    const fetchProjectOverview = async () => {
      const projectOverviews = await getProjectOverviews()
      const hostname = window.location.hostname
      const candidates = projectOverviews.filter((overview) =>
        overview.publishingSettings && overview.publishingSettings.hostnames
          ? overview.publishingSettings.hostnames.includes(hostname)
          : false
      )
      // TODO : Add proper client telemetry using Sentry or something, instead of just logging to console
      if (candidates.length === 0) {
        console.log(
          `ERROR: No project configuration found for hostname ${hostname}`
        )
        setProjectOverview(LoadingState.error)
      } else if (candidates.length > 1) {
        console.log(
          `ERROR: Multiple project configurations found for hostname ${hostname}, using ${candidates[0].id}`
        )
        // TODO: We should add some validation logic to make sure we get what we need from the DB
        setProjectOverview(candidates[0])
      } else {
        console.log(`Found project configuration, using ${candidates[0].id}`)
        // TODO: We should add some validation logic to make sure we get what we need from the DB
        setProjectOverview(candidates[0])
      }
    }

    fetchProjectOverview()
  }, []) // TODO: Not sure if this empty array is correct

  return projectOverview
}
